import { useState } from "react";
import { Button } from "../../../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../ui/dialog";
import { CheckCircle } from "lucide-react";
import { useSelector } from "react-redux";
import { jobCompleted } from "../../../../../apiManager/shared/jobCompleted";

export function ServiceCompletedDialog({ job, role }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const userInfo = useSelector(state => state.auth.userInfo);

  const handleJobCompleted = async () => {
    try {
      setLoading(true);
      
      // Call the jobCompleted API
      await jobCompleted(job._id, role === 'shoveller' ? userInfo.user.id : job.ShovelerInfo[0].ShovelerId, role);

      // Close dialog and refresh page or update state
      setOpen(false);
      // You might want to add a callback prop here to update parent state
      window.location.reload(); // Simple refresh approach
      
    } catch (error) {
      console.error('Error completing job:', error);
      alert('Failed to mark job as completed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-secondary text-white">
          <CheckCircle className="w-4 h-4 mr-2" />
          Mark Complete
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-secondary" />
            Mark Service as Completed
          </DialogTitle>
          <DialogDescription>
            {role === 'shoveller' ? (
              <p className="my-2">Confirm that you have successfully completed this service. This will notify the homeowner and process the payment.</p>
            ) : (
              <p className="my-2">Confirm that helper has successfully completed this service. This will process the payment.</p>
            )}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleJobCompleted}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700"
          >
            {loading ? "Completing..." : "Confirm Completion"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}